const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API_BASE = `${BACKEND_URL}/api`;

export function formatApiError(error) {
  const detail = error?.detail ?? error?.message ?? error;
  if (detail == null) return "Não foi possível concluir o pedido.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((item) => item?.msg || JSON.stringify(item)).join(" ");
  }
  return detail?.msg || String(detail);
}

export async function apiRequest(path, options = {}) {
  const headers = { ...(options.headers || {}) };
  if (!(options.body instanceof FormData) && options.body !== undefined) {
    headers["Content-Type"] = "application/json";
  }
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
    credentials: "include",
  });
  const contentType = response.headers.get("content-type") || "";
  const payload = contentType.includes("application/json") ? await response.json() : null;
  if (!response.ok) {
    const error = new Error(formatApiError(payload?.detail || payload));
    error.detail = payload?.detail || payload;
    error.status = response.status;
    throw error;
  }
  return payload;
}

export function submitBooking(form, files) {
  const body = new FormData();
  Object.entries(form).forEach(([key, value]) => body.append(key, String(value ?? "")));
  files.forEach((file) => body.append("photos", file));
  return apiRequest("/booking-requests", { method: "POST", body });
}

export function submitContact(form) {
  return apiRequest("/contact-messages", {
    method: "POST",
    body: JSON.stringify(form),
  });
}

export function loginAdmin(email, password) {
  return apiRequest("/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
}

export function getCurrentUser() {
  return apiRequest("/auth/me");
}

export function logoutAdmin() {
  return apiRequest("/auth/logout", { method: "POST" });
}

export function getAdminOverview() {
  return apiRequest("/admin/overview");
}

export function getAdminRequests(status = "") {
  const query = status ? `?status=${encodeURIComponent(status)}` : "";
  return apiRequest(`/admin/booking-requests${query}`);
}

export function updateAdminRequest(id, status, adminNotes) {
  return apiRequest(`/admin/booking-requests/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ status, admin_notes: adminNotes }),
  });
}
